import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getFinishedPhases } from "core-integration/src/store/phases/reducers";
import { getWinnersByPhase } from "core-integration/src/store/winners/reducers";
import { fetchPhaseWinners } from "core-integration/src/store/winners/thunks";
import Link from "plos/src/components/links/Link";
import Subheading from "plos/src/components/Subheading";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { Cell, Column, Row, Table } from "plos/src/components/Table";
import { contentMain } from "plos/src/layouts";
import { fixedTable } from "plos/src/styles/utils.css";
import { useEffect, useState } from "react";
import { TableBody, TableHeader } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MonthFilter } from "../WinnersFilters";
import {
  managerName,
  winnersPointsCell,
  winnersPointsColumn,
  winnersRankCell,
  winnersRankColumn,
  winnersTeamColumn,
} from "./winnersTables.css";

const MonthTable = () => {
  const { t } = useTranslation("prizes");
  const dispatch = useDispatch<ThunkDispatch>();
  const finishedPhases = useSelector((state: RootState) =>
    getFinishedPhases(state).filter((p) => p.id !== 1),
  );
  const phaseWinners = useSelector(getWinnersByPhase);

  const [prizePhase, setPrizePhase] = useState(
    finishedPhases.length ? finishedPhases[finishedPhases.length - 1].id : 0,
  );

  useEffect(() => {
    if (prizePhase) {
      dispatch(fetchPhaseWinners(prizePhase));
    }
  }, [dispatch, prizePhase]);

  const handlePrizePhaseChange = (phaseId: number) => setPrizePhase(phaseId);

  const phaseWinnersList = phaseWinners[prizePhase] || [];

  return (
    <SurfaceContainer>
      <div className={contentMain}>
        <Subheading>
          {t("winnersTable.monthlyWinners", "Monthly Winners")}
        </Subheading>
        {finishedPhases.length ? (
          <MonthFilter
            finishedPhases={finishedPhases}
            prizePhase={prizePhase}
            handlePrizePhaseChange={handlePrizePhaseChange}
          />
        ) : (
          <span>
            {t("winnersTable.noCompletedPhases", "No Completed Phases")}
          </span>
        )}
        <Table
          className={fixedTable}
          aria-label={
            t("winnersTable.monthlyWinners", "Monthly Winners") as string
          }
        >
          <TableHeader>
            <Column isRowHeader className={winnersRankColumn}>
              {t("winnersTable.rank", "Rank")}
            </Column>
            <Column className={winnersTeamColumn}>
              {t("winnersTable.teamAndManager", "Team & Manager")}
            </Column>
            <Column className={winnersPointsColumn}>
              {t("winnersTable.phasePoints", "Phase Pts")}
            </Column>
          </TableHeader>
          <TableBody>
            {phaseWinnersList.slice(0, 1).map((w) => (
              <Row key={w.entry_id}>
                <Cell className={winnersRankCell}>{w.rank_sort}</Cell>
                <Cell>
                  <Link to={`/entry/${w.entry_id}/history`}>
                    <div>
                      <strong>{w.team_name}</strong>
                      <br />
                      <span className={managerName}>
                        {w.first_name} {w.last_name}
                      </span>
                    </div>
                  </Link>
                </Cell>
                <Cell className={winnersPointsCell}>{w.points}</Cell>
              </Row>
            ))}
          </TableBody>
        </Table>
      </div>
    </SurfaceContainer>
  );
};

export default MonthTable;
